// extracted by mini-css-extract-plugin
module.exports = {"details":"IpdTypeDetails_details__34OPG"};